import { createApp } from 'vue';
import ZipToTarGzConverter from '@/Components/ZipToTarGzConverter.vue';
import '@styles/app.css';

createApp(ZipToTarGzConverter).mount('#zip-to-tar-gz-converter');
